import React, { useEffect } from 'react';
// import ServicesButtonList from '../components/ServicesButtonList';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Schema from './Schema';
import ServiceNavigator from './ServiceNavigator';

const SolarSystemConsultation = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="font-sans text-gray-900 bg-gray-100">
    <Schema />
      {/* Hero Section */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-3xl">
          <h2 className="text-5xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Solar System Consultation
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-4 italic">
            Ensure Your Solar Investment is Built Right – Compliant, Safe & High Performing
          </p>
        </div>
      </section>

      {/* Intro Paragraph */}
      <section
        className="px-6 max-w-4xl mx-auto text-gray-700 text-lg sm:text-xl leading-relaxed mb-14 text-justify"
        data-aos="fade-up"
      >
        <p>
          At <strong>SolarCare International</strong>, we offer expert <em>consultation services for solar PV system installations</em> across
          <em> domestic, commercial, and utility-scale</em> sectors in Sri Lanka. This service is designed to protect solar owners from substandard
          installations, ensure compliance with <strong>SLSEA guidelines</strong>, and deliver long-term safety and performance.
        </p>
      </section>

      {/* Why Our Consultation is Essential */}
      <section className="px-6 max-w-4xl mx-auto mb-20" data-aos="fade-up">
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">
          Why Our Consultation is Essential
        </h2>
        <p className="text-gray-700 text-base sm:text-lg text-justify mb-4">
          Experts with over a decade of experience and 44,000+ kW of systems audited and supported, many Sri Lankan solar consumers still lack access to
          unbiased, technically sound advice.
        </p>
        <p className="font-semibold italic text-gray-700 mb-4">
          Our Consultation Service bridges that gap—providing pre-installation technical support to ensure your system is:
        </p>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 text-base text-black leading-relaxed w-full">
          {[
            'Installed by your vendor to SLSEA and CEB standards',
            'Designed correctly based on your energy needs and site conditions',
            'Compliant with electrical safety codes and energy regulations',
            'Sized and oriented for maximum long-term performance',
            'Protected against fire hazards and low-quality components',
          ].map((item, i) => (
            <li key={i} className="bg-white rounded-full px-6 py-3 text-center" data-aos="fade-up">
              {item}
            </li>
          ))}
        </ul>
      </section>

      {/* What's Included */}
      <section className="px-6 max-w-4xl mx-auto mb-20" data-aos="fade-up">
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">What’s Included</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-3 text-base sm:text-lg">
          <li><em>System Design Review</em> – Layout, tilt, inverter sizing, configuration</li>
          <li><em>Load & Yield Analysis</em> – Avoid under/oversizing</li>
          <li><em>Component Assessment</em> – Panels, SPD, isolators, wiring</li>
          <li><em>Site Visit (Optional)</em> – Shading, routing, roof integrity</li>
          <li><em>SLSEA Compliance</em> – Ensure approvals are met</li>
          <li><em>Safety Review</em> – Grounding, surge, fire prevention</li>
          <li><em>Installer Checklist</em> – Best practice document for contractors</li>
        </ul>
      </section>

      {/* Who Can Benefit */}
      <section className="px-6 max-w-4xl mx-auto mb-20" data-aos="fade-up">
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">Who Can Benefit?</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-3 text-base sm:text-lg">
          <li>Homeowners planning rooftop solar</li>
          <li>Businesses investing in solar</li>
          <li>Real estate developers adding PV</li>
          <li>Industries needing grid-tied or hybrid setups</li>
          <li>Anyone unsure of their installer's proposal</li>
        </ul>
      </section>

      {/* Deliverables */}
      <section className="px-6 max-w-4xl mx-auto mb-20" data-aos="fade-up">
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">Deliverables</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-3 text-base sm:text-lg">
          <li>Written <em>Pre-Installation Review Report</em></li>
          <li>Design & component assessment summary</li>
          <li>SLSEA compliance checklist tailored to your project</li>
          <li>Optional post-installation verification (extra)</li>
        </ul>
      </section>

      {/* Why Choose Us */}
      <section className="px-6 max-w-4xl mx-auto mb-20" data-aos="fade-up">
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">Why Choose Solar Care International?</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-3 text-base sm:text-lg">
          <li>Experts with 10+ years in solar inspections & design validation</li>
          <li>Neutral third-party—<em>not tied to any vendor</em></li>
          <li>Helped 1,000+ clients avoid costly errors</li>
          <li>Consulted from 3kW rooftops to multi-MW farms</li>
        </ul>
      </section>

      {/* Call to Action */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
          Book Your Consultation Today
        </h2>
        <p className="max-w-xl mb-4">
          Protect your investment and gain peace of mind. We’ll help you make informed decisions, avoid common pitfalls, and ensure performance.
        </p>
        <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Get in Touch
          </h2>
          <p className="mb-2 font-medium">Solar Care International Pvt Ltd</p>
          <p className="mb-1">No.44/1A, Chapel Lane, Nugegoda, Sri Lanka</p>
          <p className="mb-1">+94 114 199 225 / +94 777 129 021</p>
          <p>
            <a
              href="mailto:info@solarcareinternational.com"
              className="text-blue-400 hover:text-blue-200 underline transition"
            >
              info@solarcareinternational.com
            </a>
          </p>
        </div>
      </section>

      {/* <ServicesButtonList /> */}
      <ServiceNavigator />
    </div>
  );
};

export default SolarSystemConsultation;